import LeftNavRender from "../utils/LeftNav/Renderer";

documentOnReady(LeftNavRender.renderLeftNav);